import Render from '@Views/root/help/home-help.html'
import { Vue, Component } from 'vue-property-decorator'
import {IBreadcrumbItem} from "@Store/types/breadcrumb";
import {breadcrumb} from "@Store/modules/breadcrumb";
import {user} from "@Store/modules/user";
import {support} from "@Store/modules/support";
import {notif} from "@Store/modules/notification";
import {RequestStatus} from "@Enums/request";

@Render
@Component({})
export class HomeHelp extends Vue {
	private HELP2LS_BASE_URL : string = 'https://support.osteo2ls.com/'
	mounted(){
		this.initializeBreadcrumb()
	}

	private initializeBreadcrumb(): void {
		let item1: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.help').toString(), link: "help" }
		let item2: IBreadcrumbItem = { label: this.$i18n.t('vm.root.breadcrumb.home-help').toString() }
		breadcrumb.updateItems([item1, item2])
	}

	get isJitbitAccountSynchronized(): boolean {
		return user.user.isJitbitAccountSynchronized;
	}

	get isCreatingJitbit(): boolean {
		return support.statusCreating === RequestStatus.Loading
	}

	async createJitBitAccount(){

		try {
			await support.createJitbitUser();
			notif.success({
				message: this.$i18n.t('vm.root.help.home-help.no-support-account.success').toString(),
				actions: [],
				delay: 5000,
				canClose: true
			})
		} catch (error){

			notif.error({
				message: error.toString(),
				actions: [],
				delay: 5000,
				canClose: true
			})
		} finally {
			await user.reloadUser()
		}

	}

	goToHelp2ls() {
		window.open(`${this.HELP2LS_BASE_URL}`, '_blank')
	}

	resetPasswordHelp2ls() {
		window.open(`${this.HELP2LS_BASE_URL}User/LostPassword`, '_blank')
	}


}
